// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import style from "./YoomDateTimePicker.module.scss";
import { useDatetimePickerData } from "../../../hooks/useDatetimePickerData";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";

const weeks = [0, 1, 2, 3, 4, 5, 6];

export const YoomDateTimePicker = ({
  datetime,
  target,
  value = null,
  setDateFormat,
  open = false,
  editCell = null,
  keyFlag = false,
  customSelectedStyle = "",
  setKeyFlag,
  timeZone,
}) => {
  const { t } = useTranslation();
  const week_ja = [
    t("YoomDateTimePicker.日"),
    t("YoomDateTimePicker.月"),
    t("YoomDateTimePicker.火"),
    t("YoomDateTimePicker.水"),
    t("YoomDateTimePicker.木"),
    t("YoomDateTimePicker.金"),
    t("YoomDateTimePicker.土"),
  ];

  const [current, setCurrent] = useState(value ? moment.tz(value, timeZone) : moment.tz(timeZone));
  const [days, setDays] = useState([]);
  const [year, setYear] = useState(current.year());
  const [month, setMonth] = useState(current.month());
  const [date, setDate] = useState(current.date());
  const [hour, setHour] = useState(current.hours());
  const [minute, setMinute] = useState(current.minute());
  const [isOpen, setOpen] = useState(open);
  const [fade, setFade] = useState(false);
  const [wrapStyle, setStyle] = useState();
  const [openPullDown, setOpenPullDown] = useState(false);
  const [hourFocus, setHourFocus] = useState(false);
  const [minuteFocus, setMinuteFocus] = useState(false);
  const pullDownRef = useRef();

  const format = datetime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD";

  const next = (month, year) => {
    if (month < 11) {
      setMonth(month + 1);
    } else {
      setMonth(0);
      setYear(year + 1);
    }
  };

  const prev = (month, year) => {
    if (month > 0) {
      setMonth(month - 1);
    } else {
      setMonth(11);
      setYear(year - 1);
    }
  };

  const timeHourInput = (hour) => {
    hour = Number(hour);
    if (hour >= 0) {
      if (hour < 0 || hour > 23) {
        hour = 0;
      }
      setHour(hour);
      const DateTime = [year, month, date, hour, minute];
      setCurrent(moment.tz(DateTime, timeZone));
      setDateFormat(moment.tz(DateTime, timeZone));
      target.current.value = moment.tz(DateTime, timeZone).format(format);
      target.current.focus();
    }
  };

  const timeMinuteInput = (minute) => {
    minute = Number(minute);
    if (minute >= 0) {
      if (minute < 0 || minute > 59) {
        minute = 0;
      }
      setMinute(minute);
      const DateTime = [year, month, date, hour, minute];
      setCurrent(moment.tz(DateTime, timeZone));
      setDateFormat(moment.tz(DateTime, timeZone));
      target.current.value = moment.tz(DateTime, timeZone).format(format);
    }
  };

  const select = (date) => {
    if (date.month() !== month) {
      setMonth(date.month());
      setYear(date.year());
    }
    setCurrent(date);
    setDate(date.date());
    setDateFormat(date);
    target.current.value = moment.tz(date, timeZone).format(format);
    if (editCell !== null) {
      target.current.focus();
    }
    target.current.focus();
  };

  useEffect(() => {
    if (keyFlag) {
      setOpenPullDown(false);
      setKeyFlag(false);
    }
    function onFocus() {
      setOpen(true);
    }

    function onBlur() {
      setOpen(false);
    }

    function onMouseOver() {
      if (!keyFlag) {
        target.current.focus();
        setOpenPullDown(true);
        setOpen(true);
      }
    }

    function onMouseOut() {
      setOpenPullDown(false);
    }

    if (target.current) {
      const offsetHeight = target.current.offsetHeight;
      setStyle({
        position: "absolute",
        top: `${offsetHeight === 0 ? 34 : offsetHeight}px`,
        bottom: "auto",
      });
      target.current.addEventListener("focus", onFocus);
      target.current.addEventListener("click", onFocus);
      target.current.addEventListener("blur", onBlur);
    }

    pullDownRef.current.addEventListener("mouseover", onMouseOver);
    pullDownRef.current.addEventListener("mouseout", onMouseOut);
  }, [target.current, keyFlag]);

  useEffect(() => {
    if (isOpen || openPullDown) {
      if (!fade) {
        setFade(true);
      }
    } else {
      if (fade) {
        setFade(false);
      }
    }
  }, [isOpen, openPullDown]);
  useEffect(() => {
    if (editCell !== null) {
      setFade(true);
    }
  }, [target.current]);

  useEffect(() => {
    const stashDays = useDatetimePickerData(year, month, date, hour, minute, datetime, timeZone);
    setDays(stashDays);
  }, [year, month, hour, minute, target]);

  return (
    <div ref={pullDownRef} className={style.dateTimePicker} style={{ display: fade ? "block" : "none" }}>
      <div className="d-flex align-items-center">
        <div className={`d-flex flex-column align-items-center justify-content-center ${style.wrap}`} style={wrapStyle}>
          <div className="d-flex align-items-center justify-content-around">
            <div className="d-flex flex-column align-items-center px-2 mr-1">
              <div className={`w-100 d-flex flex-row align-items-center justify-content-between ${style.header}`}>
                <button type="button" className={style.resetBtn} onClick={() => prev(month, year)}>
                  <img src={getImageUrl(`images/icons/datetimepicker/date_prev.svg`)} />
                </button>
                <h4 className={`m-0 ${style.title}`}>
                  {year}/{(month + 1).toString().padStart(2, 0)}
                </h4>
                <button type="button" className={style.resetBtn} onClick={() => next(month, year)}>
                  <img src={getImageUrl(`images/icons/datetimepicker/date_next.svg`)} />
                </button>
              </div>
              <table className={style.table}>
                <thead>
                  <tr>
                    {weeks.map((day, day_i) => (
                      <th key={day_i}>{week_ja[day] ? week_ja[day] : ``}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {days.map((week, idx) => (
                    <tr key={idx}>
                      {week.map((moment, i) => (
                        <td
                          key={i}
                          align="center"
                          className={`${style.td} ${
                            month === moment.month() &&
                            moment.month() === current.month() &&
                            moment.date() === current.date()
                              ? `${customSelectedStyle || style.selected}`
                              : ""
                          } ${moment.month() !== month ? `${style.grayText}` : ""} test-datetime-picker`}
                          onClick={() => select(moment)}
                        >
                          {moment.date()}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {datetime && (
              <div className="d-flex align-items-center px-2 ml-1">
                <div className="d-flex flex-column align-items-center">
                  <button
                    type="button"
                    className={`${style.resetBtn} my-3`}
                    onClick={() => timeHourInput(hour - 1)}
                    disabled={!(hour > 0)}
                  >
                    {hour > 0 ? (
                      <img src={getImageUrl(`images/icons/datetimepicker/timePrev.svg`)} />
                    ) : (
                      <img src={getImageUrl(`images/icons/datetimepicker/timePrevDisabled.svg`)} />
                    )}
                  </button>
                  <h1 onMouseOver={() => setHourFocus(true)} className={style.h1}>
                    {hour.toString().padStart(2, 0)}
                  </h1>
                  <button
                    type="button"
                    className={`${style.resetBtn} my-3`}
                    onClick={() => timeHourInput(hour + 1)}
                    disabled={!(hour < 23)}
                  >
                    {hour < 23 ? (
                      <img src={getImageUrl(`images/icons/datetimepicker/timeNext.svg`)} />
                    ) : (
                      <img src={getImageUrl(`images/icons/datetimepicker/timeNextDisabled.svg`)} />
                    )}
                  </button>
                </div>
                <h1 className={style.timecorn}>：</h1>
                <div className="d-flex flex-column align-items-center">
                  <button
                    type="button"
                    className={`${style.resetBtn} my-3`}
                    onClick={() => timeMinuteInput(minute - 1)}
                    disabled={!(minute > 0)}
                  >
                    {minute > 0 ? (
                      <img src={getImageUrl(`images/icons/datetimepicker/timePrev.svg`)} />
                    ) : (
                      <img src={getImageUrl(`images/icons/datetimepicker/timePrevDisabled.svg`)} />
                    )}
                  </button>
                  <h1 onMouseOver={() => setMinuteFocus(true)} className={style.h1}>
                    {minute.toString().padStart(2, 0)}
                  </h1>
                  <button
                    type="button"
                    className={`${style.resetBtn} my-3`}
                    onClick={() => timeMinuteInput(minute + 1)}
                    disabled={!(minute < 59)}
                  >
                    {minute < 59 ? (
                      <img src={getImageUrl(`images/icons/datetimepicker/timeNext.svg`)} />
                    ) : (
                      <img src={getImageUrl(`images/icons/datetimepicker/timeNextDisabled.svg`)} />
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

YoomDateTimePicker.propTypes = {
  target: PropTypes.object,
  datetime: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  setDateFormat: PropTypes.func,
  open: PropTypes.bool,
  editCell: PropTypes.func,
  keyFlag: PropTypes.bool,
  setKeyFlag: PropTypes.func,
  customSelectedStyle: PropTypes.string,
  timeZone: PropTypes.string,
};
